import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Box, Typography, Card, CardContent, CardMedia, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import GQLQueryStatusIndicator from "../../../components/GQLQueryStatusIndicator";
import { containerStyles, headerStyles } from "../utils/styles";
import { LOAD_VIDEO_QUERY } from "../../../globals/graphql/moovsAcademy.graphql";
import { formatVideoDuration } from "./utils/formatDuration";

export default function VideoDetailPage() {
  const { videoId } = useParams<{ videoId: string }>();
  const history = useHistory();
  const { data, error, loading } = useQuery(LOAD_VIDEO_QUERY, {
    variables: { hashedId: videoId },
  });

  if (!data || loading || error) {
    return (
      <GQLQueryStatusIndicator
        name="Video Details"
        error={error}
        data={data}
        loading={loading}
      />
    );
  }

  const video = data.loadVideo;

  const constructIframeUrl = (video: any) => {
    return `https://fast.wistia.net/embed/iframe/${video.hashedId}`;
  };

  const handleBackClick = () => {
    history.push("/settings/academy");
  };

  return (
    <Box sx={containerStyles}>
      <Box sx={headerStyles}>
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton onClick={handleBackClick} sx={{ color: 'inherit' }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h2">{video.name}</Typography>
        </Box>
      </Box>

      <Box mt={3} px={3}>
        <Card>
          <CardMedia
            component="iframe"
            src={constructIframeUrl(video)}
            sx={{ height: 400 }}
            allowFullScreen
          />
          <CardContent>
            <Typography variant="body1" paragraph>
              {video.description || "No description available"}
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="flex-end">
              <Typography variant="body2" color="text.secondary">
                {formatVideoDuration(video.duration)}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
} 